export default (cookieName) => {
  cookieName = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie).split(';');

  for (let i = 0; i < decodedCookie.length; i++) {
    let cookieValue = decodedCookie[i];
    while (cookieValue.charAt(0) == ' ') {
      cookieValue = cookieValue.substring(1);
    }

    if (cookieValue.indexOf(cookieName) === 0) {
      return cookieValue.substring(cookieName.length, cookieValue.length);
    }
  }
  return null;
};
